(function() {
	'use strict';

	angular
		.module('components')
		.component('snapPackageResult', {
			bindings: {
				didClick: '&',
				snapFromOverride: '<',
				isFromPrice: '<',
				pkgCustomerName: '<',
				pkgGate: '<',
				pkgHeadline: '<',
				pkgId: '<',
				pkgImage: '<',
				pkgInfo: '<',
				pkgName: '<',
				pkgPrice: '<'
			},
			controller: 'SnapPackageResultComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/components/snap-package-result/snap-package-result-component.html'
		});
})();
